import { h } from 'preact'

const CREDITS_PER_USD = 10_000
const toCredits = (usd) => Math.round((usd || 0) * CREDITS_PER_USD).toLocaleString()
const formatTokens = (n) => Math.round(n || 0).toLocaleString()

/**
 * CostBadge — message cost + budget remaining.
 * cost: {
 *   message_cost, budget_remaining, budget_limit, budget_exceeded,
 *   unit?: 'usd'|'tokens', message_tokens?: number
 * }
 * Classic (usd): message_cost is USD → credits. Catalog (tokens): token counts.
 */
export function CostBadge({ cost, i18n }) {
  if (!cost) return null

  const unit = cost.unit === 'tokens' ? 'tokens' : 'usd'
  const msgCost = typeof cost.message_cost === 'number' ? cost.message_cost : 0
  const msgTokens = typeof cost.message_tokens === 'number' ? cost.message_tokens : null
  const remaining = typeof cost.budget_remaining === 'number' ? cost.budget_remaining : null
  const limit = typeof cost.budget_limit === 'number' ? cost.budget_limit : 0
  const exceeded = !!cost.budget_exceeded

  const showBudget = limit > 0 && remaining !== null

  let costLabel
  let remainingLabel = null
  let badgeLabel

  if (unit === 'tokens') {
    const tokensShown = msgTokens != null ? msgTokens : msgCost
    costLabel = i18n?.t('ai.cost_info.cost_tokens', {
      tokens: formatTokens(tokensShown),
      defaultValue: `${formatTokens(tokensShown)} token`
    })
    remainingLabel = showBudget
      ? i18n?.t('ai.cost_info.remaining_tokens', {
          remaining: formatTokens(remaining),
          limit: formatTokens(limit),
          defaultValue: `${formatTokens(remaining)} / ${formatTokens(limit)} token`
        })
      : null
    badgeLabel = i18n?.t('ai.budget_exceeded.badge_quota') || 'Token keret kimerült'
  } else {
    costLabel = i18n?.t('ai.cost_info.cost', {
      credits: toCredits(msgCost),
      defaultValue: `${toCredits(msgCost)} kredit`
    })
    remainingLabel = showBudget
      ? i18n?.t('ai.cost_info.remaining', {
          remaining: toCredits(remaining),
          limit: toCredits(limit),
          defaultValue: `${toCredits(remaining)} / ${toCredits(limit)} kredit`
        })
      : null
    badgeLabel = i18n?.t('ai.budget_exceeded.badge') || 'Kredit kimerült'
  }

  return (
    <div class={`ai-cost-badge d-flex align-items-center gap-3 mt-2 text-muted small${exceeded ? ' text-danger' : ''}`}>
      <span><i class="bi bi-coin me-1"></i>{costLabel}</span>
      {showBudget && (
        <span class={exceeded ? 'text-danger fw-semibold' : ''}>
          <i class="bi bi-pie-chart me-1"></i>{remainingLabel}
        </span>
      )}
      {exceeded && (
        <span class="badge bg-danger ms-1">
          {badgeLabel}
        </span>
      )}
    </div>
  )
}
